var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.svgClass,style:({ width: _vm.size + 'px', height: _vm.size + 'px', color: _vm.color }),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":`#icon-${_vm.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }